<template>
    <div class="p-16 md:p-20 text-white text-center">
        <alert ref="alert"></alert>

        <h1 class="font-light">
            boleto
        </h1>

        <div>
            por favor, só gere o boleto caso tenha certeza do pagamento.
            evite cobranças desnecessárias
        </div>

        <div class="mt-20 flex flex-col md:flex-row">
            <div class="w-full mb-5 md:mb-0 md:mr-5">
                <input type="text" v-model="document_number"
                       class="w-full h-full input"
                       name="document_number" placeholder="CPF / CNPJ">
            </div>

            <div class="w-full md:w-1/3">
                <button class="btn btn-orange w-full" @click="finish()">
                    Gerar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            plan: String
        },

        data() {
            return {
                document_number: null
            }
        },

        methods: {
            finish() {
                if(!this.document_number) {
                    this.$refs.alert.show('Informe um CPF / CNPJ');
                    return;
                }

                this.$emit('finishes', {type: 'boleto', document_number: this.document_number});
            }
        }

    }
</script>